import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
// @dynamic-i18n-keys
//   studio.subsCancellationReasons.reason.*
import ReasonProgressBar from './_partials/ReasonProgressBar';
import Flex from '@wix/da-ds/pkg/Flex';

interface Props {
  item: { reason?: number; percentage: number | null };
  index: number;
}

const SubsCancellationReasonsTableRowHeadingMobile: FC<Props> = ({ item }) => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" gap={8}>
      <div className={'f-14-bld'}>
        {t(`studio.subsCancellationReasons.reason.${item.reason ?? 0}`)}
      </div>
      <ReasonProgressBar percentage={item.percentage} />
    </Flex>
  );
};

export default SubsCancellationReasonsTableRowHeadingMobile;
